import { render, staticRenderFns } from "./SmartGrandStair.vue?vue&type=template&id=59c134a7&scoped=true&"
import script from "./SmartGrandStair.vue?vue&type=script&lang=js&"
export * from "./SmartGrandStair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c134a7",
  null
  
)

export default component.exports